/**
 * Branding constants for Locoptics (locoptics.ly)
 * Powered by بصريات الوكيل
 *
 * Logo: update src/assets/logo.svg with your Locoptics logo. The app uses it here.
 * Also copy the same file to public/branding/logo.svg for favicon and og:image.
 */

/** ?url makes Vite emit the asset URL (svgr would otherwise give a component) */
import logoSrc from "../assets/logo.svg?url";

export const SITE_URL = "https://locoptics.ly";
export const APP_NAME = "Locoptics";
export const APP_NAME_AR = "لوكوبتكس";
export const APP_TAGLINE = "بصريات الوكيل";
/** Logo URL: in-app logo from src/assets/logo.svg (mobile nav, etc.) */
export const BRANDING_LOGO_URL = logoSrc;
/** Horizontal logo for desktop nav (public/branding/logo horizontal.svg) */
export const BRANDING_LOGO_HORIZONTAL_URL = "/branding/logo%20horizontal.svg";
/** Default meta description */
export const DEFAULT_DESCRIPTION = "Locoptics - نظارات وعدسات لاصقة من بصريات الوكيل";
